import BaseComponent from "../BaseComponent";
import TextInput from "components/Properties/InputComponents/TextInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";
import ColorBoxInput from "components/Properties/InputComponents/ColorboxInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const SpriteTextComponent = ({
  selectedObject,
  textOnChange,
  colorOnChange,
  dropdownOnChange,
  dropdownOpened,
  setDropdownOpened,
  inputOnChange,
}) => {
  let guiTextColor = "#ffffff";
  let guiTextFont = "";
  let guiTextWeight = "";
  let guiTextSize = 20;
  let guiText = "";

  if (selectedObject.isSprite) {
    guiTextColor = selectedObject.userData.css.fontColor;
    guiTextFont = selectedObject.userData.css.fontFamily === "" ? "default" : selectedObject.userData.css.fontFamily;
    guiTextWeight = selectedObject.userData.css.fontWeight === "" ? "normal" : selectedObject.userData.css.fontWeight;
    guiTextSize = selectedObject.userData.css.fontSize;
    guiText = selectedObject.userData.css.textContent;
  }

  if (selectedObject.type === "Sprite") {
    return (
      <BaseComponent title="Text" foldable={true}>
        <TextInput name="TextInput" value={guiText} textOnChange={textOnChange} placeholder="Enter Text" />
        <DropDownInput
          name="Font"
          array={[
            "default",
            "serif",
            "cursive",
            "Noto Sans",
            "NEXON Lv1 Gothic",
            "NEXON Lv1 Gothic Bold",
            "yg-jalnan",
            "cookierun-black",
            "cookierun-bold",
            "cookierun-regular",
            "cyberjunkies",
            "cyberjunkies-italic",
            "scdream4",
            "scdream6",
            "scdream9",
            "junglefever",
            "junglefever-inline",
            "KBO_Dia_Gothic_bold",
            "KBO_Dia_Gothic_medium",
            "KBO_Dia_Gothic_light",
          ]}
          dropdownOnChange={dropdownOnChange}
          value={guiTextFont}
          selectedObject={selectedObject}
          dropdownOpened={dropdownOpened}
          setDropdownOpened={setDropdownOpened}
        />
        <DropDownInput
          name="FontWeight"
          array={["normal", "bold"]}
          dropdownOnChange={dropdownOnChange}
          value={guiTextWeight}
          selectedObject={selectedObject}
          dropdownOpened={dropdownOpened}
          setDropdownOpened={setDropdownOpened}
        />
        <NumberSliderInput
          name="FontSize"
          min={0}
          max={500}
          step={1}
          value={parseFloat(guiTextSize.slice(0, -2))}
          inputOnChange={inputOnChange}
        />
        <ColorBoxInput name="FontColor" objectColor={guiTextColor} colorOnChange={colorOnChange} />
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default SpriteTextComponent;
